<template>
  <div class="checkout-component">
    <p class="page-title">الرجاء الاختيار</p>
    <v-card>
      <v-tabs v-model="tab" centered dark grow>
        <v-tab class="hidden-tab" style="display: none"> </v-tab>
        <v-tab-item>
          <inRyad2 :settings="settings" v-if="settings"
        /></v-tab-item>
        <v-tab> الرياض </v-tab>
        <v-tab-item>
          <inRyad :settings="settings" v-if="settings" />
        </v-tab-item>

        <v-tab> خارج الرياض </v-tab>

        <v-tab-item>
          <outRyad :settings="settings" v-if="settings" />
        </v-tab-item>

        <v-tab @click="notFound()"> دولى </v-tab>
      </v-tabs>
    </v-card>
    <v-dialog v-model="dialog">
      <v-card class="p-5">
        <v-card-title> </v-card-title>
        <v-card-text class="m-auto">
          عذرًا الشحن الدولي غير متاح حاليًا
        </v-card-text>
        <v-card-actions>
          <button
            @click="
              dialog = false;
              tab = 1;
            "
            class="green-btn"
          >
            موافق
          </button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import InRyad from "./checkout/InRyad.vue";
import InRyad2 from "./checkout/InRyad2.vue";
import OutRyad from "./checkout/OutRyad.vue";
import { ServiceFactory } from "../services/ServiceFactory";
const aboutService = ServiceFactory.get("about");
export default {
  data() {
    return {
      dialog: false,
      settings: null,
      tab: null,
    };
  },
  components: {
    // Logo,
    InRyad,
    InRyad2,
    OutRyad,
  },
  methods: {
    notFound() {
      this.tab = 1;
      this.dialog = true;
    },
    async fetchSettings() {
      this.dataLoading = true;
      this.settings = await aboutService.getAboutData();
      this.dataLoading = false;
    },
  },
  created() {
    this.fetchSettings();
  },
};
</script>
<style>
.checkout-component .v-slide-group__wrapper {
  background: #fff;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.18);
  border-radius: 15px;
  color: #5a5a5a;
}
.theme--dark.v-tabs > .v-tabs-bar {
  background: #fff;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.18);
  border-radius: 15px;
  color: #5a5a5a;
}
.theme--dark.v-tabs > .v-tabs-bar:hover {
  background: #fff;
}
.theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
  color: #5a5a5a !important;
}
.v-tabs-slider {
  display: none;
}
.v-tab--active {
  background: #fed24e;
}
.m-auto {
  margin: auto;
  text-align: center;
}
.green-btn {
  background-color: #5fad66;
  color: #fff;
  padding: 12px;
  border-radius: 5px;
}
.theme--dark.v-tabs .v-tab--active:hover::before,
.theme--dark.v-tabs .v-tab--active::before {
  opacity: 0;
}
.theme--light.v-card {
  background: transparent;
  box-shadow: unset !important;
  color: #5a5a5a !important;
}
.theme--light.v-tabs-items {
  background-color: transparent !important;
  padding: 40px 0;
}
.page-title {
  text-align: center;
  font-weight: 700;
  color: #614c37;
  font-size: 15px;
}
</style>
